import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { IconSubtitles } from '../../../../../react/features/base/icons/svg';
import ContextMenuItem from '../../../../../react/features/base/ui/components/web/ContextMenuItem';
import { canStartSubtitles } from '../../../../../react/features/subtitles/functions.any';
import { subtitlesHidden } from '../../../../components/transcribing/actions.any';
import { isTranscriptionOff } from '../../../../components/transcribing/functions';
/**
 * A React {@code Component} for opening or closing the
 * {@code LocalRecordingInfoDialog}.
 *
 * @extends Component
 */
const ToggleSubtitlesButton = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    // @ts-ignore
    const { isSubtitlesHidden } = useSelector((state) => state['wildix/features/transcribing']);
    const isTranscriptionDisabled = useSelector(isTranscriptionOff);
    const getTranslate = useMemo(() => {
        let result = t('transcriptionsWildix.subtitlesDisable');
        if (isSubtitlesHidden || isTranscriptionDisabled) {
            result = t('transcriptionsWildix.subtitlesEnable');
        }
        return result;
    }, [isSubtitlesHidden, isTranscriptionDisabled]);
    const onClick = useCallback(() => {
        dispatch(subtitlesHidden(!isSubtitlesHidden));
    }, []);
    // if the participant is moderator, it can enable transcriptions and if
    // transcriptions are already started for the meeting, guests can just show them
    const visible = useSelector((state) => canStartSubtitles(state));
    if (!visible) {
        return null;
    }
    return (React.createElement(ContextMenuItem, { accessibilityLabel: t('transcriptionsWildix.subtitlesEnable'), text: getTranslate, icon: IconSubtitles, disabled: isTranscriptionDisabled, id: 'toggle-transcription-text', onClick: onClick }));
};
export default ToggleSubtitlesButton;
